import EditorialModuleArticles from '../src/EditorialModuleArticles';
export default EditorialModuleArticles;
